import React from "react";

export default function DeviceImage({ src, alt = "device", maxHeight = 160, style = {} }) {
    return (
        <div
            className="device-image-wrap"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                boxSizing: "border-box",
                ...style,
            }}
        >
            <img
                src={src}
                alt={alt}
                style={{
                    height: "100%",
                    maxHeight: maxHeight,
                    width: "auto",
                    objectFit: "contain",
                }}
            />
        </div>
    );
}